import React, { useEffect, useState } from "react";
//Importar el carousel para los mensajes rápidos.
import { Carousel } from "react-responsive-carousel";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import PrismaZoom from 'react-prismazoom';

const CarouselImagesInChat = ({ src, messageData }) => {

    const [imagesArray, setImagesArray] = useState([]);

    useEffect(() => {
        setImagesArray((prevImages) => [...prevImages, src]);
    }, [src]);
    return (
        <div className="zoomable-image" >
            <Carousel swipeable={true} infiniteLoop={true} showThumbs={false}>
                {/*-----------Mensajes-----------------*/}
                {imagesArray.map( (imageSRC) =>
                <div className="zoomable-image" key={imageSRC}>
                     <PrismaZoom>
                    <img src={imageSRC} alt="image" />
                     </PrismaZoom>
                </div>)}
            </Carousel>
        </div>
    )
};

export default CarouselImagesInChat;